module.exports = __webpack_public_path__ + "static/media/po-reman-5.f0eedf92.png";